// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"feee1eab","180":"b752b262","861":"8f8c797e"}[chunkId] + ".css";
};